import React, { ForwardedRef, forwardRef } from "react";
import "./TextInput.css";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    className?: string;
    errorBorder?: boolean;
    isRequired?: boolean;
}

const TextInput = forwardRef(
    ({ label, error, className = "", errorBorder, style, isRequired, ...props }: TextInputProps, ref: ForwardedRef<HTMLInputElement>) => {
        return (
            <div className={`text-input-container ${className}`} style={style}>
                {label && <label className="text-input-label">{label}{isRequired && <span className="astrikSign"> *</span>}</label>}
                <input
                    ref={ref}
                    type="text"
                    className={`text-input ${error}`}
                    {...props}
                />
                {error && <p className="text-input-error-message">{error}</p>}
            </div>
        );
    }
);

TextInput.displayName = "TextInput";

export default TextInput;
